// Imports
import Axios from '@/config/AxiosConfig';
import {useAuthStore} from "@/stores/auth";

// Get Users
export const getUsers = async (status) => {
    let authStore = useAuthStore();
    // console.log(authStore,'authstore');
    let mod = authStore.getMod;
    const url = `/user/list/${status}/${mod}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getAllUsers = async (status) => {
    let authStore = useAuthStore();
    // console.log(authStore,'authstore');
    let mod = authStore.getMod;
    const url = `/user/list`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Module's users and branches
export const getModPermissionsData = async (mod) => {
    const url = `/user/get-mode-data/${mod}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get User
export const getUser = async (id) => {
    const url = `/user/get/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add User
export const addUser = async (payload) => {
    const url = '/user/add';

    try {
        // console.log(payload, 'payload api');

        const { data } = await Axios.post(url, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update User
export const updateUser = async (payload) => {
    const url = '/user/update';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update User Profile
export const updateUserProfile = async (payload) => {
    const url = '/user/update-profile';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update User Status
export const updateUserStatus = async (id, status) => {
    const url = `/user/change-status/${id}/${status}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Sort Users
export const sortUsers = async (payload) => {
    const url = "/user/sort";

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Invite User
export const inviteUser = async (payload) => {
    const url = "/user/invite";

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};


export const updateEditUserInvite = async (payload) => {
    const url = "/user/update-invite-user";

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Invite User
export const reSendInviteUser = async (payload) => {
    const url = "/user/resend-invite";

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
